<app-alert></app-alert>

<div class="row mt-2">
    <div class="form-group col mb-n1">
        <h1>Product Availability</h1>
    </div>
</div>

<div [formGroup]="branchSelectForm" class="card mb-3 mt-2" [ngClass]="{ 'sticky-is-sections': isSticky }">
    <div class="card-body bg-light p-3">
        <div class="input-group input-group-sm w-lg-50" style="margin-bottom: 10px">
            <div class="input-group-prepend">
                <span class="input-group-text bg-secondary text-light">Filter</span>
            </div>
            <input class="form-control" placeholder="Search" type="text" autofocus="autofocus" (keyup)="tableFiltring($event)" />
        </div>
        <ng-select
            *ngIf="accountService.currentUser.roles[0] !== 'branch'"
            [items]="branches"
            [loading]="branchBusy"
            bindLabel="branchName"
            bindValue="branchId"
            formControlName="branchId"
            class="w-md-25"
        >
        </ng-select>
    </div>
</div>

<div class="card mb-3 mt-2" [ngClass]="{ 'sticky-sections': isSticky, 'sticky-sections-sidebar-open': sharedService.sidebarOpen }">
    <div class="card-body section-availity-container">
        <div class="left" (click)="scrollSections('left')">
            <i class="fas fa-chevron-left"></i>
        </div>
        <div class="section-availity-list" id="section-availity-list">
            <ng-container *ngFor="let item of items; let index = index">
                <div
                    class="section-availity-item"
                    *ngIf="!items[index - 1] || item.sectionName !== items[index - 1].sectionName"
                    (click)="setSectionPosition(item.sectionId)"
                >
                    <span>
                        {{ item.sectionName }}
                    </span>
                </div>
            </ng-container>
        </div>
        <div class="right" (click)="scrollSections('right')">
            <i class="fas fa-chevron-right"></i>
        </div>
    </div>
</div>

<ngx-datatable
    #table
    class="bootstrap-table table-hover"
    [rows]="items"
    [headerHeight]="0"
    [footerHeight]="38"
    [rowHeight]="'auto'"
    [columnMode]="'standard'"
    [scrollbarH]="true"
    [groupRowsBy]="'sectionName'"
    [groupExpansionDefault]="true"
>
    <ngx-datatable-group-header>
        <ng-template let-group="group" let-expanded="expanded" ngx-datatable-group-header-template>
            <div class="grouping-header" [ngClass]="group.value[0].sectionName" [id]="'grouping-header-' + group.value[0].sectionId">
                <span> {{ group.value[0].sectionName }} </span>
            </div>
        </ng-template>
    </ngx-datatable-group-header>

    <ngx-datatable-column name="Product Name" prop="productName" [cellClass]="'tb-col-3'" [headerClass]="'tb-col-3'" [draggable]="false" [resizeable]="false">
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            <div>
                <span> {{ value }}</span>
                <ng-container *ngIf="branchId || accountService.currentUser.roles[0] === 'branch'">
                    <span class="badge badge-success table-badge" *ngIf="row.state"> Available </span>
                    <span class="badge badge-danger table-badge" *ngIf="!row.state"> UnAvailable </span>
                </ng-container>
            </div>
            <div class="cells-mobile"></div>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
        [cellClass]="'actions-cell tb-col-3'"
        [headerClass]="'actions-cell tb-col-3'"
        [draggable]="false"
        [resizeable]="false"
        [sortable]="false"
    >
        <ng-template let-row="row" let-rowIndex="rowIndex" let-value="value" ngx-datatable-cell-template>
            <ng-container *ngIf="accountService.currentUser.roles[0] === 'branch'">
                <!-- <div class="btn-group ml-2" ngbDropdown container="body">
                    <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" ngbDropdownToggle>Actions</button>
                    <div class="dropdown-menu" ngbDropdownMenu>
                        <a class="dropdown-item btn-sm" (click)="confirmState(row.productId, 'available')">Available</a>
                        <a class="dropdown-item btn-sm" (click)="confirmState(row.productId, 'unvailable')">Unvailable</a>
                    </div>
                </div> -->
                <div class="form-group available-switch">
                    <div class="custom-control custom-switch custom-switch-xl">
                        <input
                            type="checkbox"
                            [attr.id]="'hasOffer-' + rowIndex"
                            [checked]="row.state ? true : false"
                            class="custom-control-input"
                            (change)="onCheckboxChange($event, row)"
                        />
                        <label [attr.for]="'hasOffer-' + rowIndex" class="custom-control-label cursor-pointer"></label>
                    </div>
                </div>
            </ng-container>
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-footer></ngx-datatable-footer>
</ngx-datatable>
